import {AppState} from "../../../store/store";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {connect, useDispatch} from "react-redux";
import {actions, Control, Form} from "react-redux-form";
import _ from "lodash";
import {putRelay} from "../../../services/relays.service";
import InputIcon from "@material-ui/icons/Input";
import CustomSelect from "../../../components/custom-select/custom-select";
import {modes} from "../../../lists/mode-list";
import {DEVICE_MODE} from "../../../enums/device-mode";
import {inputsList} from "../../../lists/inputs-list";
import CustomInput from "../../../components/custom-input/custom-input";
import {sensorList, humiditySensors} from "../../../lists/sensors-list";
import {Button} from "@material-ui/core";
import {DeviceProps} from "./device-view";
import {OutputSettingsTimerMode} from "./output-settings-time-mode";
import {InputModeContainer} from "./input-mode-container";
import LensIcon from "@material-ui/icons/Lens";

interface SensorChildProps {
    id: string;
    device: DeviceProps;
    state: AppState;
    deviceName: string;
    names: object;
    inputKey: string;
}



const PureSensorChild: React.FC<SensorChildProps> = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedValue, setSelectedValue] = useState(props.device.mode);
    const [currentTimeMode, setCurrentTimeMode] = useState(0);
    const [currentDeviceStatus, setCurrentDeviceStatus] = useState<boolean | undefined>(false);
    const [inputSelectedValue, setInputSelectedValue] = useState(props.device.input || 0);
    const [hydrostatSelectedValue, setHydrostatSelectedValue] = useState(12);
    const [timeSettings, setTimeSettings] = useState<any[]>(props.device.timeSettings || []);
    const [dissableButtons, setDissableButtons] = useState(false);
    useEffect(() => {
        setSelectedValue(props.device.mode);
        setCurrentDeviceStatus(props.device.isActive);
        setTimeSettings(props.device.timeSettings as any[]);
        dispatch(actions.change(props.id + '.reactionTime', props.device.reactionTime));
        dispatch(actions.change(props.id + '.holdingTime', props.device.holdingTime));
    }, [props.device]);
    const tmpTime = _.get(props.state, props.id + '.tmpTime', {});

    const handleChangeChips = (chips: any) => {
        dispatch(actions.change(props.id + '.timeSettings', chips));
    }
    const handleSubmit = (device: any) => {
        setDissableButtons(true)
        putRelay(props.id, device, currentTimeMode, !currentDeviceStatus).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentDeviceStatus(!currentDeviceStatus);
    }
    const handleSave = () => {
        setDissableButtons(true)
        const device = _.get(props.state, props.id, {});
        setCurrentDeviceStatus(false)
        const deviceToSend = _.assign({}, device, {
            isActive: false
        });
        putRelay(props.id, deviceToSend, currentTimeMode, false).finally(() => setTimeout(() => setDissableButtons(false), 1000))
    }
    const handleOnChangeSelect = (e: any) => {
        setSelectedValue(e.target.value);
        dispatch(actions.change(props.id + '.mode', e.target.value))
    }
    useEffect(() => {
        console.log("NAMES: ", props.names)
    }, [props.names])
    return (
        <div className='card default-card'>
            <div className="card-body">
                <Form
                    model={props.id}
                    onSubmit={(device) => handleSubmit(device)}>
                        <div className='d-flex justify-content-center'>
                                <span className=''>{currentDeviceStatus ? t('active') :  t('notactive')}</span>
                                <LensIcon className={`ml-2 ${currentDeviceStatus ? 'greenLens' : 'redLens'}`}/>
                            </div>
                    <div className='card-title-container'>
                        <div className='card-title-with-icon'>
                            <InputIcon/>
                            
                        </div>
                        <span className='card-title'>{props.deviceName}</span>
                    </div>
                    <div className='default-row'>
                        <div className='default-field'>
                            <Control.select
                                model={props.id + '.mode'}
                                component={CustomSelect}
                                value={selectedValue}
                                label={t('deviceMode')}
                                onChange={e => handleOnChangeSelect(e)}
                                mapProps={{
                                    options: () => modes.map((mode) => {
                                        return {
                                            value: mode.value,
                                            label: t('deviceMode.' + mode.label)
                                        }
                                    }),
                                    id: () => props.id + '.mode'
                                }}
                                id={props.id + '.mode'} />
                        </div>
                        {
                            selectedValue === DEVICE_MODE.INPUT && <div className='default-field'>
                                <Control.select
                                    model={props.id + '.input'}
                                    component={CustomSelect}
                                    value={inputSelectedValue}
                                    label={t(props.inputKey)}
                                    onChange={(e: any) => setInputSelectedValue(e.target.value)}
                                    mapProps={{
                                        options: () => inputsList.map((input) => {
                                            return {
                                                key: input.key,
                                                label: _.get(props.names, 'inputs.' + input.key, input.key),
                                                value: input.value
                                            }
                                        }),
                                        id: () => props.id + '.input'
                                    }}
                                    id={props.id + '.input'} />
                            </div>
                        }
                        {
                            selectedValue === DEVICE_MODE.TIMER && <div className='output-settings-timer-mode-container'>
                                <OutputSettingsTimerMode onChangeChips={(d) => handleChangeChips(d)} onChange={(mode) => setCurrentTimeMode(mode)} timeSettings={timeSettings} tmpTime={tmpTime}/>
                            </div>
                        }
                        {
                            selectedValue === DEVICE_MODE.TERMOSTAT && <div className='d-flex justify-content-between termostat-row'>
                                <div className='default-field'>
                                    <Control
                                        model={props.id + ".temp1"}
                                        component={CustomInput}
                                        defaultValue={props.device.temp1}
                                        label={t('temp1')}
                                        id={props.id + '.temp1'} />
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model={props.id + ".temp2"}
                                        component={CustomInput}
                                        defaultValue={props.device.temp2}
                                        label={t('temp2')}
                                        id={props.id + '.temp2'} />
                                </div>
                            </div>
                        }
                        {
                            selectedValue === DEVICE_MODE.HYDROSTAT && <div className='d-flex justify-content-between termostat-row'>
                                <div className='default-field'>
                                    <Control
                                        model={props.id + ".hydrostat1"}
                                        component={CustomInput}
                                        defaultValue={props.device.h1}
                                        label={t('hydrostat1')}
                                        id={props.id + '.hydrostat1'} />
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model={props.id + ".hydrostat2"}
                                        component={CustomInput}
                                        defaultValue={props.device.h2}
                                        label={t('hydrostat2')}
                                        id={props.id + '.hydrostat2'} />
                                </div>
                            </div>
                        }
                    </div>
                    {
                        selectedValue === DEVICE_MODE.HYDROSTAT && <div className='default-row'>
                            <div className='default-field'>
                                <Control.select
                                    model={props.id + '.input'}
                                    component={CustomSelect}
                                    value={hydrostatSelectedValue}
                                    label={t(props.inputKey)}
                                    onChange={(e: any) => setHydrostatSelectedValue(e.target.value)}
                                    mapProps={{
                                        options: () => humiditySensors.map((item) => {
                                            return {
                                                key: item.key,
                                                label: _.get(props.names, 'humidity.' + item.key, item.key),
                                                value: item.value
                                            }
                                        }),
                                        id: () => props.id + '.input'
                                    }}
                                    id={props.id + '.input'} />
                            </div>
                            <div className='output-settings-timer-mode-container'>
                                <OutputSettingsTimerMode onChangeChips={(d) => handleChangeChips(d)} onChange={(mode) => setCurrentTimeMode(mode)} timeSettings={timeSettings} tmpTime={tmpTime}/>
                            </div>
                        </div>
                    }
                    {
                        selectedValue === DEVICE_MODE.INPUT && <InputModeContainer id={props.id} />
                    }
                    {
                        selectedValue === DEVICE_MODE.TERMOSTAT && <div className='default-row'>
                            <div className='default-field'>
                                <Control.select
                                    model={props.id + '.input'}
                                    component={CustomSelect}
                                    value={inputSelectedValue}
                                    label={t('input')}
                                    onChange={(e: any) => setInputSelectedValue(e.target.value)}
                                    mapProps={{
                                        options: () => sensorList.map((item) => {
                                            return {
                                                key: item.key,
                                                label: _.get(props.names, 'temperature.' + item.key, item.key),
                                                value: item.value
                                            }
                                        }),
                                        id: () => props.id + '.input'
                                    }}
                                    id={props.id + '.input'} />
                            </div>
                            <div className='output-settings-timer-mode-container'>
                                <OutputSettingsTimerMode onChangeChips={(d) => handleChangeChips(d)} onChange={(mode) => setCurrentTimeMode(mode)} timeSettings={timeSettings} tmpTime={tmpTime}/>
                            </div>
                        </div>
                    }
                    <div className='modal-action-row'>
                        <Button variant="outlined" disabled={dissableButtons} onClick={handleSave} type='button' color="primary" className='modal-default-button'>
                            {t('save')}
                        </Button>
                        <Button variant="contained" disabled={dissableButtons} type='submit' color="primary" className='modal-default-button'>
                            {!currentDeviceStatus ? t('activate') : t('deactivate')}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    state: state
});
export const SensorChild = connect(mapStateToProps)(PureSensorChild);